import coord from './coord'
import type { TilePositionXY } from './TilePositionXY.type'

export default function toCoord(position: TilePositionXY): TilePositionXY {
  return coord(position.x, position.y)
}
